import { Trans, useTranslation } from 'react-i18next';

import { sendAnalyticPrintableWorkoutDownload } from 'services/analytics';

import GuidesList from 'components/GuidesList';
import Guide from 'components/GuidesList/components/Guide';
import { Text } from 'components/library';

import { useGetBonusWorkouts } from './bonusWorkouts';

import * as S from './styled';

const PrintableWorkouts = () => {
    const { t } = useTranslation();
    const workouts = useGetBonusWorkouts();

    return (
        <S.Container>
            <S.GuidesListWrapper>
                <Text type="h5" center mb={12}>
                    <Trans i18nKey="printableWorkouts.title" />
                </Text>
                <Text type="medium-text" center mb={24}>
                    <Trans i18nKey="printableWorkouts.messageSent" />
                </Text>
                {workouts.length ? (
                    <GuidesList
                        guides={workouts}
                        title={t('printableWorkouts.title')}
                        dataLocator="printableWorkout"
                        onDownload={sendAnalyticPrintableWorkoutDownload}
                    />
                ) : (
                    <Guide title={t('guides.notFound')} />
                )}
            </S.GuidesListWrapper>
        </S.Container>
    );
};

export default PrintableWorkouts;
